import { React } from "react";
import { Tab, Tabs, Box } from "@mui/material";
import stringUtils from "../../../utils/string_utils";
import commonColorUtils from "../../../utils/common_colors";
import CommonTextWithRoundedShape from "../../../components/CommonTextWithRoundedShape.jsx";

const LocationRepositoryTabs = ({
  activeTabValue,
  handleOnChangeTabs,
  count,
}) => {
  const styleOfTab = {
    width: "160px",
    fontFamily: "Inter, Arial, sans-serif",
    color: commonColorUtils.primaryGrey600,
    fontWeight: 600,
    margin: "6px 25px",
    fontSize: "14px",
    "&.Mui-selected": {
      color: commonColorUtils.primaryMainBlue,
    },
  };
  return (
    <>
      <Tabs
        value={activeTabValue}
        onChange={handleOnChangeTabs}
        sx={{
          width: "100%",
        }}
        TabIndicatorProps={{
          style: {
            backgroundColor: commonColorUtils.primaryMainBlue,
          },
        }}
      >
        <Tab
          label={
            <Box display="flex" alignItems="center">
              {stringUtils.locations}
              <CommonTextWithRoundedShape text={count} />
            </Box>
          }
          sx={{
            ...styleOfTab,
            textTransform: "none",
          }}
        />
      </Tabs>
    </>
  );
};
export default LocationRepositoryTabs;
